import type { ErrorReportPayload } from './types'

/**
 * 리포트 전송. 반드시 bare fetch 를 사용한다 — 앱의 HTTP 클라이언트를 타면
 * 그 클라이언트의 에러 처리(토스트, 401 리다이렉트, 브레드크럼)가 다시 발동해
 * 캡처 루프를 만들 수 있다. 실패는 어떤 형태로도 표면화되지 않는다.
 */
export function sendReport(
  endpoint: string,
  payload: ErrorReportPayload,
  fetchFn: typeof fetch,
): void {
  try {
    const body = JSON.stringify(payload)
    void fetchFn(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      // 페이지 이탈 중에도 전송이 살아남도록. 단 keepalive 바디는 ~64KB 제한이
      // 있으므로 페이로드 필드 캡이 총량을 그 아래로 유지해야 한다.
      keepalive: true,
      body,
    }).then(
      () => undefined,
      () => undefined,
    )
  } catch {
    // 직렬화/호출 실패 포함 전부 무시 — 리포터는 절대 앱에 영향을 주지 않는다
  }
}
